import { useState } from 'react';
import { Column, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { IPostingEntity } from '../../../domain/Postings';

const LIST_WIDTH = '420px';

const SCROLL_CONTAINER_STYLE: React.CSSProperties = {
  maxHeight: 96,
  overflowY: 'auto',
  marginBottom: 8,
};

const ELLIPSIS_STYLE: React.CSSProperties = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const ELLIPSIS_CLIP_STYLE: React.CSSProperties = {
  overflow: 'clip',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const VIEW_MORE_BUTTON_STYLE: React.CSSProperties = {
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  textDecoration: 'underline',
};

const INITIAL_VISIBLE_COUNT = 3;

interface ISuspendedPostingsListProps {
  postings: IPostingEntity[];
}

export const SuspendedPostingsList = ({ postings }: ISuspendedPostingsListProps) => {
  const [showAll, setShowAll] = useState(false);

  const hasMore = postings.length > INITIAL_VISIBLE_COUNT;
  const visiblePostings = showAll ? postings : postings.slice(0, INITIAL_VISIBLE_COUNT);

  if (showAll) {
    return (
      <Column
        gap={4}
        pr={8}
        style={{ ...SCROLL_CONTAINER_STYLE, width: LIST_WIDTH }}
      >
        {postings.map((posting) => (
          <Typography
            key={posting.id}
            variant="body1"
            color={colors.neutral[500]}
            style={ELLIPSIS_CLIP_STYLE}
          >
            • {posting.title ?? ''}
          </Typography>
        ))}
      </Column>
    );
  }

  return (
    <Column gap={4} style={{ width: LIST_WIDTH }}>
      {visiblePostings.map((posting) => (
        <Typography
          key={posting.id}
          variant="body1"
          color={colors.neutral[500]}
          style={ELLIPSIS_STYLE}
        >
          • {posting.title ?? ''}
        </Typography>
      ))}

      {hasMore && (
        <Row justify="end">
          <button
            type="button"
            style={VIEW_MORE_BUTTON_STYLE}
            onClick={() => setShowAll(true)}
          >
            <Typography
              variant="body1"
              color={colors.secondary[500]}
              bold
            >
              View More
            </Typography>
          </button>
        </Row>
      )}
    </Column>
  );
};
